module.exports = __webpack_public_path__ + "static/img/sdab_zxtj_two.90951f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sdab_zxtj_two.png
// module id = HLkJ
// module chunks = 21